import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQueryWithHeaders } from '../api';
import { endpoints } from '../endpoints';

interface FetchHasClaimAttachmentWritebackSupportRequest {
  currentPracticeId: string;
  currentOrganizationId: string;
}

interface GetHasClaimAttachmentWritebackSupportResponse {
  hasClaimAttachmentWritebackSupport: boolean;
}

const fetchHasClaimAttachmentWritebackSupport = async ({
  currentPracticeId,
  currentOrganizationId,
}: FetchHasClaimAttachmentWritebackSupportRequest) => {
  const data =
    await makeAPIRequestReactQueryWithHeaders<GetHasClaimAttachmentWritebackSupportResponse>(
      `/${endpoints.claimWritebackSupport}`,
      undefined,
      {
        Practice: currentPracticeId,
        Org: currentOrganizationId,
      },
      'GET',
    );
  return data.hasClaimAttachmentWritebackSupport;
};

export const useHasClaimAttachmentWritebackSupport = () => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery({
    queryKey: [
      'claim-attachment-writeback-support',
      currentOrganizationId,
      currentPracticeId,
    ],
    queryFn: () => {
      if (!currentPracticeId || !currentOrganizationId) {
        throw new Error('Missing practice or organization ID');
      }
      return fetchHasClaimAttachmentWritebackSupport({
        currentPracticeId,
        currentOrganizationId,
      });
    },
    enabled: !!currentPracticeId && !!currentOrganizationId,
  });
};
